/* disc-sticky-inject.js — Sticky ATC bar with real Add to Cart */
(function() {
  'use strict';
  if (!document.querySelector('.disc-hero')) return;

  var ACCENT = '#e8621a';
  var FONT = "-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif";
  var BTN_STYLE = 'background:'+ACCENT+';color:#fff;border:none;padding:10px 24px;border-radius:8px;font-weight:700;font-size:.88rem;cursor:pointer;white-space:nowrap;font-family:'+FONT+';transition:background .2s';

  /* --- Build bars --- */
  var topHTML = '<div id="disc-sticky-top" style="position:fixed;z-index:2147483647;left:0;right:0;top:0;opacity:0;pointer-events:none;transform:translateY(-100%);transition:transform .35s cubic-bezier(.16,1,.3,1),opacity .35s;background:rgba(255,255,255,.96);backdrop-filter:blur(12px);-webkit-backdrop-filter:blur(12px);border-bottom:1px solid #e8e8e5;box-shadow:0 2px 12px rgba(0,0,0,.06)">' +
    '<div style="max-width:1100px;margin:0 auto;padding:10px 20px;display:flex;align-items:center;justify-content:space-between;gap:12px">' +
    '<span style="font-size:.88rem;color:#1a1a1a" id="disc-sticky-top-text">Discovery Bundle <strong>€15.99</strong></span>' +
    '<button id="disc-sticky-top-btn" style="'+BTN_STYLE+'">Add to Cart — €15.99</button>' +
    '</div></div>';

  var bottomHTML = '<div id="disc-sticky-bottom" style="position:fixed;z-index:2147483647;left:0;right:0;bottom:0;opacity:0;pointer-events:none;transform:translateY(100%);transition:transform .35s cubic-bezier(.16,1,.3,1),opacity .35s;background:#fff;border-top:1px solid #e8e8e5;box-shadow:0 -4px 20px rgba(0,0,0,.08)">' +
    '<div style="max-width:1100px;margin:0 auto;padding:12px 16px;display:flex;align-items:center;justify-content:space-between;gap:12px">' +
    '<div style="display:flex;flex-direction:column">' +
    '<span style="font-size:.85rem;font-weight:700;color:#1a1a1a" id="disc-sticky-bot-name">Discovery Bundle</span>' +
    '<span style="font-size:.9rem;font-weight:800;color:'+ACCENT+'" id="disc-sticky-bot-price">€15.99</span>' +
    '</div>' +
    '<button id="disc-sticky-bot-btn" style="'+BTN_STYLE+'">Add to Cart</button>' +
    '</div></div>';

  /* --- Media queries --- */
  var style = document.createElement('style');
  style.textContent = '@media(max-width:768px){#disc-sticky-top{display:none!important}}@media(min-width:769px){#disc-sticky-bottom{display:none!important}}';
  document.head.appendChild(style);

  /* --- Remove old --- */
  ['disc-sticky-top','disc-sticky-bottom'].forEach(function(id) {
    var el = document.getElementById(id);
    if (el) el.remove();
  });

  /* --- Inject on body --- */
  var w = document.createElement('div');
  w.innerHTML = topHTML + bottomHTML;
  while (w.firstChild) document.body.appendChild(w.firstChild);

  var topBar = document.getElementById('disc-sticky-top');
  var bottomBar = document.getElementById('disc-sticky-bottom');
  var topBtn = document.getElementById('disc-sticky-top-btn');
  var botBtn = document.getElementById('disc-sticky-bot-btn');

  /* --- ATC handler: reuses discBundleAdd if available, else direct cart/add --- */
  function stickyATC() {
    /* If tier 3 with scent picker is selected but no scent chosen, scroll to picker */
    var active = document.querySelector('.disc-bundle-card--active');
    if (active && active.dataset.hasPicker === 'true') {
      if (!window._discScent || !window._discScent.vid) {
        document.getElementById('disc-bundle-selector').scrollIntoView({behavior:'smooth',block:'start'});
        return;
      }
    }

    /* Use existing discBundleAdd function */
    if (typeof window.discBundleAdd === 'function') {
      window.discBundleAdd();
      return;
    }

    /* Fallback: direct add */
    var bundleVid = window.discSelectedVariant || (window.discProductData && window.discProductData.variantId);
    if (!bundleVid) return;
    var items = [{ id: parseInt(bundleVid), quantity: 1 }];

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function(r) { return r.json(); }).then(function() {
      var opus = document.getElementById('opus-sticky-cart');
      if (opus) opus.click();
    });
  }

  if (topBtn) topBtn.addEventListener('click', stickyATC);
  if (botBtn) botBtn.addEventListener('click', stickyATC);

  /* --- Sync price/label with selected tier --- */
  function syncPrice() {
    var active = document.querySelector('.disc-bundle-card--active');
    if (!active) return;
    var price = active.getAttribute('data-price') || '15.99';
    var nameEl = active.querySelector('.disc-bundle-card__name');
    var label = nameEl ? nameEl.textContent.trim() : 'Discovery Bundle';

    var topText = document.getElementById('disc-sticky-top-text');
    var botName = document.getElementById('disc-sticky-bot-name');
    var botPrice = document.getElementById('disc-sticky-bot-price');

    if (topText) topText.innerHTML = label + ' <strong>€' + price + '</strong>';
    if (topBtn) topBtn.textContent = 'Add to Cart — €' + price;
    if (botName) botName.textContent = label;
    if (botPrice) botPrice.textContent = '€' + price;
    if (botBtn) botBtn.textContent = 'Add to Cart';
  }

  document.addEventListener('click', function(e) {
    if (e.target.closest && e.target.closest('.disc-bundle-card')) {
      setTimeout(syncPrice, 50);
    }
  });
  syncPrice();
  setTimeout(syncPrice, 1000);

  /* --- Show/hide on scroll --- */
  var visible = false;
  function update() {
    var show = window.scrollY > 500;
    if (show === visible) return;
    visible = show;
    [topBar, bottomBar].forEach(function(bar) {
      if (!bar) return;
      bar.style.opacity = show ? '1' : '0';
      bar.style.pointerEvents = show ? 'auto' : 'none';
      bar.style.transform = show ? 'translateY(0)' : (bar === topBar ? 'translateY(-100%)' : 'translateY(100%)');
    });
  }
  window.addEventListener('scroll', update, { passive: true });
  update();
})();